import type { Variants } from 'motion/react';
import { transitions } from './tokens';

export const cardFadeUpVariants: Variants = {
  hidden: { opacity: 0, y: 16, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: transitions.entrance,
  },
};

export const staggerContainerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: transitions.staggerDelay,
    },
  },
};

export const heroRevealVariants: Variants = {
  hidden: { opacity: 0, y: 20, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { ...transitions.fade, duration: 0.6 },
  },
};

export const toastVariants: Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: transitions.soft,
  },
  exit: {
    opacity: 0,
    y: 8,
    transition: transitions.fade,
  },
};

export const miniPlayerMobileVariants: Variants = {
  hidden: { y: '100%' },
  visible: {
    y: 0,
    transition: transitions.soft,
  },
  exit: {
    y: '100%',
    transition: transitions.soft,
  },
};

export const miniPlayerDesktopVariants: Variants = {
  hidden: { opacity: 0, scale: 0.95, y: 20 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: transitions.soft,
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    y: 20,
    transition: transitions.fade,
  },
};

export const pageVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { ...transitions.fade, duration: 0.2 },
  },
  exit: {
    opacity: 0,
    transition: { ...transitions.fade, duration: 0.2 },
  },
};

export const iconSwapVariants: Variants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: transitions.snappy,
  },
  exit: {
    opacity: 0,
    scale: 0.8,
    transition: { ...transitions.fade, duration: 0.15 },
  },
};

export const celestialToggleVariants: Variants = {
  hidden: { opacity: 0, rotate: -90, scale: 0.5 },
  visible: {
    opacity: 1,
    rotate: 0,
    scale: 1,
    transition: transitions.snappy,
  },
  exit: {
    opacity: 0,
    rotate: 90,
    scale: 0.5,
    transition: { ...transitions.fade, duration: 0.2 },
  },
};
